import moment from 'moment-timezone';
import React, { useContext, useEffect, useState, useRef } from 'react';
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import styled from 'styled-components';
import { useToast } from '../../controller/ToastController';
import '../../styles/CustomModal.css';
import ConciergeController, {
  CHAT_SENDER_CLIENT,
  CHAT_SENDER_HOTEL,
  ConciergeChatDetailType,
  ConciergeChatType,
} from '../../controller/ConciergeController';

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
  roomName: string;
  chatDetail: ConciergeChatDetailType[];
  isMobile: boolean;
  chat: ConciergeChatType;
  currentStore: any;
  setChatDetail: any;
  status: number;
};

const ChatDetailModal = ({
  isVisible,
  setVisible,
  roomName,
  chatDetail,
  isMobile,
  chat,
  currentStore,
  setChatDetail,
  status,
}: Props) => {
  const showToast = useToast();

  // const [height, setHeight] = useState<number>(0);

  const [reply, setReply] = useState<string>('');
  const [isTranslate, setIsTranslate] = useState<boolean>(true);
  const [isComposing, setIsComposing] = useState<boolean>(false);

  const chatEndRef = useRef<HTMLDivElement | null>(null);

  const onCloseModal = () => {
    setVisible(false);
  };
  const scrollToBottom = () => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleCompositionStart = () => {
    setIsComposing(true);
  };

  const handleCompositionEnd = () => {
    setIsComposing(false);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (isComposing) return;

    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendRequest();
    }
  };

  const sendRequest = async () => {
    if (reply === '') {
      showToast('답변을 입력해주세요.', 'error');
    } else {
      const newMessage = {
        sender: CHAT_SENDER_HOTEL,
        sendAt: new Date().toISOString(),
        origin: reply,
        content_kr: reply,
        failed: false,
      };

      try {
        const oParams = {
          store_id: currentStore.value,
          concierge_id: chat.conciergeId,
          accessor: CHAT_SENDER_HOTEL,
          message: reply,
        };

        setChatDetail((prevChatDetail: any) => [...prevChatDetail, newMessage]);
        setReply('');
        const oRes: any = await ConciergeController.writeMessage(oParams);

        if (oRes && oRes.data.ok) {
        } else {
          setChatDetail((prevChatDetail: any) =>
            prevChatDetail.map((msg: any) => (msg === newMessage ? { ...msg, failed: true } : msg)),
          );
        }
      } catch (err) {
        console.log('err-->', err);

        setChatDetail((prevChatDetail: any) =>
          prevChatDetail.map((msg: any) => (msg === newMessage ? { ...msg, failed: true } : msg)),
        );
      }
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [chatDetail]);

  return (
    <Modal
      open={isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: 'chatDetailModalOverlay',
        modal: 'chatDetailModal',
        root: 'customModalRoot',
      }}
      showCloseIcon={!isMobile}
      animationDuration={150}>
      <Style>
        <div className={`modalWrapper ${chatDetail[0].content_kr === null && 'notKr'}`}>
          <div className="modalTitle">
            {isMobile && (
              <img
                onClick={() => setVisible(false)}
                className="closeIcon"
                src={`${process.env.PUBLIC_URL}/svg/ic_back_bold.svg`}
                alt="back"
              />
            )}
            <div className="headerBar" />
            <h2>{roomName}</h2>
            {chatDetail[0].content_kr && (
              <div className="translateWrap">
                <button
                  className={`translate ${isTranslate && 'active'}`}
                  onClick={() => setIsTranslate(true)}>
                  <h4>번역</h4>
                </button>
                <button
                  className={`translate ${!isTranslate && 'active'}`}
                  onClick={() => setIsTranslate(false)}>
                  <h4>원문</h4>
                </button>
              </div>
            )}
          </div>

          <div className="modalContent">
            <div className="chatWrap">
              {chatDetail.map((item, index) => (
                <div key={index} className={`chat ${item.sender === CHAT_SENDER_HOTEL && 'mine'}`}>
                  {item.sender === CHAT_SENDER_HOTEL && !item.failed && (
                    <p>
                      {`${new Date(item.sendAt).getHours() > 12 ? '오후' : '오전'} ${moment(
                        new Date(item.sendAt),
                      ).format('HH:mm')}`}
                    </p>
                  )}
                  {item.sender === CHAT_SENDER_HOTEL && item.failed && (
                    <div className="flex">
                      <img
                        src={`${process.env.PUBLIC_URL}/svg/ic_important.svg`}
                        alt="답변보내기"
                      />
                      <p className="failedMsg">전송실패</p>
                    </div>
                  )}
                  <h4 className={`${!isTranslate && item.origin.length === 0 && 'empty'}`}>
                    {!isTranslate || item.content_kr === null ? item.origin : item.content_kr}
                  </h4>
                  {item.sender === CHAT_SENDER_CLIENT && (
                    <p>{`${new Date(item.sendAt).getHours() > 12 ? '오후' : '오전'} ${moment(
                      new Date(item.sendAt),
                    ).format('HH:mm')}`}</p>
                  )}
                </div>
              ))}
              <div ref={chatEndRef} />
              {status === 1 && (
                <div className="chat finished">
                  <h4>상담이 종료되었습니다</h4>
                </div>
              )}
            </div>
            {status !== 1 && (
              <div className="receivedWrap">
                <textarea
                  id={isMobile ? 'resizeArea' : ''}
                  value={reply}
                  onChange={(e) => setReply(e.target.value)}
                  placeholder="답변을 입력해주세요"
                  onKeyDown={handleKeyPress}
                  disabled={status === 1}
                  onCompositionStart={handleCompositionStart}
                  onCompositionEnd={handleCompositionEnd}
                />
                <button onClick={sendRequest} className="confirmButton">
                  {isMobile ? (
                    <img src={`${process.env.PUBLIC_URL}/svg/ic_receive.svg`} alt="답변보내기" />
                  ) : (
                    <h3>답변 보내기</h3>
                  )}
                </button>
              </div>
            )}
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default ChatDetailModal;

const Style = styled.div`
  .flex {
    display: flex;
    align-items: center;
    gap: 6px;
  }
  li::marker {
    color: #4dd2ae;
  }

  .modalWrapper {
    display: flex;
    height: 70vh;
    height: 70dvh;
    flex-direction: column;
    gap: 16px;
    overflow: scroll;
    text-align: left;
  }
  .modalWrapper.notKr {
    gap: 40px;
  }
  .modalTitle {
    .headerBar {
      width: 44px;
      height: 5px;
      margin: 0 auto;
      border-radius: 10px;
      background: #4dd2ae;
    }
    h2 {
      margin-top: 22px;
      font-size: 24px;
      font-weight: 500;
      color: #555;
      text-align: center;
    }
    .translateWrap {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 0 8%;
      gap: 8px;
      .translate {
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 4px 18px;
        border-radius: 5px;
        border: 1px solid #cecece;
        h4 {
          font-size: 16px;
          font-weight: 500;
          color: #979797;
        }
      }
      .translate.active {
        border: 1px solid #4dd2ae;
        h4 {
          font-weight: 600;
          color: #4dd2ae;
        }
      }
    }
  }

  .modalContent {
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: 100%;
    padding: 0 8%;
    overflow: auto;
    .chatWrap {
      height: 100%;
      display: flex;
      flex-direction: column;
      gap: 10px;
      background: #ecf5f3;
      /* border: 1px solid #cecece; */
      border: none;
      border-radius: 10px;
      padding: 20px;
      overflow: auto;

      .chat {
        display: flex;
        position: relative;
        align-items: flex-end;
        justify-content: flex-start;
        white-space: pre-line;
        width: 100%;

        h4 {
          font-size: 18px;
          line-height: 26px;
          color: #555555;
          font-weight: 400;
          padding: 6px 20px;
          background: #ffffff;
          border-radius: 20px;
          white-space: pre-line;
          word-break: break-all;
          max-width: 80%;
        }
        p {
          font-size: 12px;
          line-height: 18px;
          font-weight: 500;
          color: #737373;
          margin: 0 0 0 6px;
        }
        h4.empty {
          width: 60px;
          height: 38px;
        }
      }
      .chat.mine {
        justify-content: flex-end;

        h4 {
          color: #ffffff;
          background: #40977f;
        }
        p {
          text-align: right;
          margin: 0 6px 0 0;
        }
        .failedMsg {
          font-weight: 500;
          color: #ff6060;
        }
      }
    }

    .chat.finished {
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      h4 {
        padding: 4px 20px;
        border-radius: 50px;
        border: 1px solid #e5e5e5;
        font-size: 12px;
        line-height: 18px;
        font-weight: 400;
        color: #979797;
        background: transparent;
      }
    }

    .receivedWrap {
      display: flex;
      flex-direction: column;
      gap: 16px;
      textarea {
        width: 100%;
        height: 120px;
        padding: 12px 24px;
        background: #ffffff;
        border: 1px solid #cecece;
        border-radius: 10px;
        font-size: 18px;
        line-height: 24px;
        color: #555555;
        font-weight: 400;
      }
      textarea::placeholder {
        color: #979797;
      }
    }
  }

  .confirmButton {
    margin: 30px 0 0 0;
    padding: 12px 0;
    background: #4dd2ae;
    border: none;
    h3 {
      font-weight: 700;
    }
  }

  @media (max-width: 900px) {
    .modalWrapper {
      height: 100vh;
      display: flex;
      gap: 10px;
      padding-top: 20px;
    }

    .closeIcon {
      position: absolute;
      top: 30px;
      left: 20px;
    }

    .headerBar {
      display: none;
    }

    .modalTitle {
      position: relative;
      padding: 30px 0;
      h2 {
        margin: 0;
      }
    }

    .modalContent {
      padding: 0 4%;
      gap: 0;

      .chatWrap {
        gap: 10px;
        /* border: 1px solid #cecece; */
        border: none;
        background: #eeeeee;
        padding: 30px 10px;
        margin-bottom: 20px;
        height: calc(100vh - 190px);
        height: calc(100dvh - 190px);
        .chat {
          h4 {
            font-size: 14px;
            line-height: 22px;
            padding: 4px 18px;
          }
          p {
            font-size: 10px;
            margin: 0 0 0 4px;
          }
        }
        .chat.mine {
          p {
            margin: 0 4px 0 0;
          }
        }
      }

      .receivedWrap {
        flex-direction: row;
        gap: 8px;
        padding: 10px 0;

        textarea {
          height: 48px;
        }
      }
    }

    .confirmButton {
      margin: 0;
      padding: 0 18px;
      background: #4dd2ae;
      border: none;
      h3 {
        font-weight: 700;
      }
      img {
        margin-top: 6px;
      }
    }
  }
`;
